import React, {useRef, useState, useEffect, useContext, startTransition} from "react";
import { isEmpty } from "../../helpers/utils";

import "./index.css";
import { votingApi } from '../../helpers/fetcher';
import { ACTIONS } from '../../store/Actions';
import { DataContext } from "../../store/GlobalState";

function translationHtml(response) {
  const data = response && response.data;
  if (typeof data !== "string") {
    return "";
  }
  const visible = data
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  return visible ? data : "";
}

const CardBody = ({ phenomenon,  isTranslated, langForTransState }) => {
  const cardBodyRef = useRef()
  const cardBodyRef2 = useRef()

  const {
    state: { getTheWholeCardHtmlElms,  isAutoTrans },
    dispatch,
  } = useContext(DataContext);

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(() => cardBodyRef.current?.innerHTML)

  useEffect(() => {
    let isCurrent = true;
    const fetcher = async () => {
      let res1 = null;
      try {
        res1 = await votingApi.translation("en", langForTransState, originalTitle);
      } catch (error) {
        res1 = null;
      }
      if (!isCurrent) {
        return;
      }
      settranslations(translationHtml(res1) ? { res1 } : null);
    };
    if (isTranslated && originalTitle) {
      fetcher();
    }
    return () => {
      isCurrent = false;
    };
  }, [ isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    startTransition(() => {
      dispatch({
        type: ACTIONS.DATAFORTRANSLATIONCARDBODY,
      payload: {
        body: translations?.res1?.data,
      }
    })
    })
  }, [translations, dispatch])

  useEffect(() => {
    if (!!phenomenon?.body) {
      if (true) {
        if (!!cardBodyRef.current?.innerHTML && !cardBodyRef2.current) {
          cardBodyRef2.current = cardBodyRef.current?.innerHTML
        }
        !!cardBodyRef2.current && !originalTitle && setoriginalTitle(() => cardBodyRef2.current)

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD2,
        //   payload:  true
        // })
      }
    }
  }, [isTranslated, phenomenon, dispatch, originalTitle])

  return phenomenon && !isEmpty(phenomenon) ? (
    <>
      {phenomenon?.body && (!isTranslated || !translationHtml(translations?.res1)) && (
        <div
          ref={cardBodyRef}
          id="card-body"
          dangerouslySetInnerHTML={{ __html: phenomenon?.body }}
        ></div>
      )}
      {phenomenon?.body && !!isTranslated && !!translationHtml(translations?.res1) && (
        <div
          id="card-body"
          dangerouslySetInnerHTML={{ __html: translationHtml(translations?.res1) }}
        ></div>
      )}
    </>
  ) : null;
};

export default CardBody;
